import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'

// components
import { CButton } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from 'src/components/details/company-policy-details/AppDetails';
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'
import AppModalFilePreview from 'src/components/modal/AppModalFilePreview';

// helpers
import Axios from '../../helpers/axios'
import useToastMessage from 'src/helpers/toast-message'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

const CompanyPolicyDetails = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const { id } = params
  const { showError } = useToastMessage();

  const [companyPolicyDetail, setCompanyPolicyDetail] = useState('')
  const [openFilePreview, setOpenFilePreview] = useState(false)

  const handleCardHeaderButton = () => {
    navigate(`/company-policy/edit/${id}`)
  }

  useEffect(() => {
    fetchDetailCompanyPolicy()
  }, [id]);

  const fetchDetailCompanyPolicy = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/company-policy/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setCompanyPolicyDetail(data?.value)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  return (
    <>
      {openFilePreview && (
        <AppModalFilePreview
          setOpenFilePreview={setOpenFilePreview}
          file={openFilePreview}
        />
      )}
      <div className='d-grid gap-2 d-md-flex justify-content-md-start mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/company-policy/list')}>
          Back
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<h4>Company Policy Details</h4>}
            headerButton="Edit"
            handleCardHeaderButton={handleCardHeaderButton}
          />
        }
        bodyContent={
          <AppDetails
            companyPolicyDetails={companyPolicyDetail}
          />
        }
        lowerBodyContent={
          <AppCard 
            className='mb-4'
            headerTitle={<h4>Attachments</h4>}
            bodyContent={
              <>
                {
                  companyPolicyDetail?.attachments?.length > 0 ? (
                    <FormFileThumbnail 
                      name='attachments'
                      colSize='4'
                      files={companyPolicyDetail?.attachments}
                      className='justify-content-start align-items-center'
                      isDetailPage={true}
                      handleViewFile={setOpenFilePreview}
                    />
                  )
                  : (
                    <>Not Found</>
                  )
                }
              </>
            }
          />
        }
      />
    </>
  )
}

export default CompanyPolicyDetails